export const ORANGE_COLOR_6 = '#fa8c16';
export const BLUE_COLOR_6 = '#1890ff';
export const GREEN_COLOR_6 = '#52c41a';
export const GREEN_COLOR_1 = '#f6ffed';
export const GREY_COLOR_2 = '#fafafa';
export const GREY_COLOR_3 = '#f5f5f5';
export const GREY_COLOR_4 = '#f0f0f0';
export const GREY_COLOR_6 = '#bfbfbf';
export const GREY_COLOR_8 = '#595959';
export const GREY_COLOR_ANTD_BORDER = '#e6e6e6';
export const RED_COLOR_1 = '#fff1f0';
export const RED_COLOR_6 = '#f5222d';
export const YELLOW_COLOR_1 = '#feffe6';
